import { render, staticRenderFns } from "./AwardView.vue?vue&type=template&id=0b2fa3ae&scoped=true"
import script from "./AwardView.vue?vue&type=script&lang=js"
export * from "./AwardView.vue?vue&type=script&lang=js"
import style0 from "./AwardView.vue?vue&type=style&index=0&id=0b2fa3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2fa3ae",
  null
  
)

export default component.exports